<template>
  <DocumentEditionPage
      :business="business"
      :client-name="clientName"
      :active-category="activeCategory"
      :active-document-number="activeDocumentNumber"
      :is-editable="false"
      :title-input="titleInput"
      :business-elements="businessElements"
      :totals="totals"
      :default-unit-price="defaultUnitPrice"
      :default-tva-percent="defaultTvaPercent"
  />
</template>

<script>
import DocumentEditionPage from "@/components/businessEdition/DocumentEditionPage.vue";
import {BUSINESS_DOCUMENT_TYPE_ENUM} from "@/models/businessDocumentTypeEnum";

export default {
  name: 'DepositDocument',
  components: {DocumentEditionPage},
  props: {
    business: {type: Object, default: undefined},
    clientName: {type: String, default: ''},
    defaultUnitPrice: {default: undefined},
    defaultTvaPercent: {default: undefined},
  },
  computed: {
    activeCategory() {
      return BUSINESS_DOCUMENT_TYPE_ENUM.DEPOSIT.label;
    },
    activeDocumentNumber() {
      return this.business ? this.business.depositNumber : '';
    },
    titleInput() {
      return {label: 'Titre', value: this.business ? this.business.title : '', type: 'text', readOnly: true};
    },
    businessElements() {
      if (!this.business) return [];
      return [{
        type: 'element',
        text: {value: 'Acompte', type: 'text', readOnly: true},
        durationQuantity: {value: 1, type: 'number', readOnly: true},
        unitPrice: {value: this.business.deposit, type: 'number', readOnly: true},
        discountedRate: {value: 0, type: 'number', readOnly: true},
        tva: {value: 0, type: 'number', readOnly: true},
        amount: {value: this.business.deposit, type: 'number', readOnly: true},
      }];
    },
    totals() {
      return {
        htAmount: this.business.deposit,
        // TODO Il faut gérer la TVA sur l'accompte
        tvaAmount: 0,
        ttcAmount: this.business.deposit,
      }
    }
  },
};
</script>